import {FACTION_SKIN_CURRENCIES} from '../../constants/factions/skins';

/**
 * Цена обличия фракции. Обычно она в нуменах (priceNumens), у редких обличий —
 * в кристаллах (priceCrystals, например бывшие рубиновые образы). Если заданы
 * обе, в ход идут кристаллы: их не зададут случайно.
 *
 * Одна и та же функция считает цену и на сервере (/api/buy-skin), и на
 * странице фракции — чтобы показанная цена не разошлась со списанной.
 *
 * @param {object} [skin] - конфиг обличия из ALL_FACTION_SKINS
 * @returns {{currency: string, amount: number}|null} null — обличие не продается
 */
export const getFactionSkinPrice = (skin) => {
  if (skin?.priceCrystals > 0) {
    return {currency: FACTION_SKIN_CURRENCIES.CRYSTALS, amount: skin.priceCrystals};
  }
  if (skin?.priceNumens > 0) {
    return {currency: FACTION_SKIN_CURRENCIES.NUMENS, amount: skin.priceNumens};
  }
  return null;
};
